"use strict";
import Api from "../api/api";
import { Flash } from "../components/flash_messages";
import WaitingSpinner from "../components/waiting_spinner";
var RemoveFromWaiting = React.createClass({
  getInitialState: function() {
    return {
      removingFromWaiting: false
    };
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.removingFromWaiting }, /* @__PURE__ */ React.createElement("div", { className: "alert-box  secondary" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, "It looks like you've sent a message on an invoice that has already been processed or approved. Do you want to remove it from the waiting queue?\xA0"), /* @__PURE__ */ React.createElement("div", { className: "row" }, " ", this.removeButton())));
  },
  removeButton: function() {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--caution remove-from-waiting__button",
        onClick: this.removeFromWaiting
      },
      "Remove from Waiting"
    );
  },
  removeFromWaiting: function() {
    this.setState({ removingFromWaiting: true });
    Api.ExceptionedItems.clearActiveItem(this.props.itemId).then(() => {
      this.setState({ removingFromWaiting: false });
      this.props.onComplete();
      Flash.success("Item Successfully Removed From Waiting!");
    }).catch(() => this.setState({ removingFromWaiting: false }));
  }
});
export default RemoveFromWaiting;
